import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Box, Typography, Grid, Card, CardMedia, IconButton, Tooltip, LinearProgress, Button, Modal, Fade, Backdrop, useTheme } from '@mui/material';
import { motion } from 'framer-motion';
import { ViewComfy, ViewList, Edit, Add, Share, Delete } from '@mui/icons-material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faImage as farImage } from '@fortawesome/free-regular-svg-icons';
import { faVideo as fasVideo } from '@fortawesome/free-solid-svg-icons';
import { useQuery, useQueryClient } from 'react-query';
import { getFolder,DeleteFileInFolder, deleteFile } from '../../../api/services'; // Make sure this function is defined properly in your services.
import RightPreview from './RightPreview';
import AddFileDrawer from './AddFileDrawer';
import { plus } from '../../../assets';
import MultiFileUploadDrawer from './MultiFileUploadDrawer';
import QRCode from 'qrcode'; // Import qrcode package
import ReactPlayer from 'react-player';
import { Add as AddIcon, Folder as FolderIcon, Share as ShareIcon, Link as LinkIcon } from '@mui/icons-material';
import CreateFolderDrawer from '../CreateFolderDrawer';
import { toast } from 'react-toastify';



interface Folder {
  name: string;
  files: any[];
  filesdata: any[];
  subfolders: any[];
}

const FolderDetails: React.FC<{ folderData: any, refetch: any }> = ({ folderData, refetch }) => {
  const { id } = useParams<{ id?: string }>();
  const queryClient = useQueryClient();
  const [isGridView, setIsGridView] = useState(true);
  const [selectedFileIndex, setSelectedFileIndex] = useState<number | null>(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [isDrawerOpen1, setIsDrawerOpen1] = useState(false);
  const [editingFile, setEditingFile] = useState<any | null>(null);
  const [folderUrl, setFolderUrl] = useState<string>('');
  const [modalOpen, setModalOpen] = useState(false);
  const [filename, setFilename] = useState('');
  const [fileId, setFileId] = useState('');
  const [filepathname, setFilepathName] = useState('');
  const [drawerOpen, setDrawerOpen] = useState(false);
  const theme = useTheme();
  const navigate = useNavigate();

  const ITEMS_PER_PAGE = 8;
const [visibleCount, setVisibleCount] = useState(ITEMS_PER_PAGE);

// Load more files
const handleShowMore = () => {
  setVisibleCount((prev) => prev + ITEMS_PER_PAGE);
};



 

  useEffect(() => {
    if (id) {
      setFolderUrl(`https://portfolio.dezignshark.com/folders/${id}`);
      refetch();
    }
  }, [id, refetch]);



  const folder: Folder = folderData;

  const handleSelectFile = (index: number) => {
    setSelectedFileIndex(index);
    setIsPreviewOpen(true);
  };

  const handleClosePreview = () => {
    setIsPreviewOpen(false);
    setSelectedFileIndex(null);
  };

  const handleEditFile = (file: any) => {
    setEditingFile(file);
    setIsDrawerOpen(true);
  };

  const handleDrawerClose = () => {
    setIsDrawerOpen(false);
    setEditingFile(null);
  };

  const handleDrawerClose1 = () => {
    setIsDrawerOpen1(false);
  };

  const handleDeleteFile = (fileId: string) => {
    deleteFile(filepathname);
    DeleteFileInFolder(fileId, id || "" );
    refetch();
    queryClient.invalidateQueries('folderData'); 
    toast.success("File Deleted Successfully!...")

  }


  const handleDeleteFolder = () => {
    setModalOpen(true);
  }

  const handleCloseModal = () => {
    setModalOpen(false);
  }




  const handleShare = () => {
    if (folderUrl) {
      // Generate the QR code for the folder URL
      QRCode.toDataURL(folderUrl, { width: 200, height: 200 }, (err, url) => {
        if (err) {
          console.error('Error generating QR code:', err);
          return;
        }

        // Create a temporary anchor tag to download the image
        const a = document.createElement('a');
        a.href = url;
        a.download = 'FolderQRCode.png';
        a.click();

        // Optionally, copy the URL to the clipboard
        navigator.clipboard.writeText(folderUrl).then(() => {
          console.log('Folder URL copied to clipboard!');
        });
      });
    }
  };




  return (
    <>
      <Box sx={{ padding: 4, backgroundColor: 'background.default', minHeight: '100vh' }}>

        {/* View Toggle */}
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 3 }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
          {/* <Typography
            variant="h6"
            gutterBottom
            component={motion.h1}
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.4 }}
            sx={{ fontWeight: 500 , mr: 1, color: 'text.primary' }}
          >
            {folder.name}
          </Typography> */}
          <Typography variant="subtitle1" color="text.secondary" sx={{ fontWeight: 450 }}>
              Folders ({folder.subfolders.length}) 
          </Typography>
          </Box>
          <Box>
            {/* <Tooltip title="Share Folder">
              <IconButton color="primary" onClick={handleShare}>
                <Share />
              </IconButton>
            </Tooltip>
            <Tooltip title="Grid View">
              <IconButton onClick={() => setIsGridView(true)}>
                <ViewComfy />
              </IconButton>
            </Tooltip>
            <Tooltip title="List View">
              <IconButton onClick={() => setIsGridView(false)}>
                <ViewList />
              </IconButton>
            </Tooltip> */}


            {/* create Folder */}
            <Tooltip title="Add Folder">
              <IconButton color="primary" onClick={() => setDrawerOpen(true)}>
                <Button
                  variant="contained"
                  onClick={() => setDrawerOpen(true)}
                  sx={{ textTransform: 'none', backgroundColor: 'primary.main', color: 'white' }}
                >
                  Add Folder
                  <img src={plus} alt="plus" style={{ width: '20px', height: '20px', marginLeft: '10px' }} />
                </Button>
              </IconButton>
            </Tooltip>

            {/* add file */}
            <Tooltip title="Add File">
              <IconButton color="primary" onClick={() => setIsDrawerOpen(true)}>
                <Button
                  variant="contained"
                  onClick={() => setIsDrawerOpen(true)}
                  sx={{ textTransform: 'none', backgroundColor: 'primary.main', color: 'white' }}
                >
                  Add File
                  <img src={plus} alt="plus" style={{ width: '20px', height: '20px', marginLeft: '10px' }} />
                </Button>
              </IconButton>
            </Tooltip>


            {/* add multiple file */}
            <Tooltip title="Add File">
              <IconButton color="primary" onClick={() => setIsDrawerOpen1(true)}>
                <Button 
                  variant="contained"
                  onClick={() => setIsDrawerOpen1(true)}
                  sx={{ textTransform: 'none', backgroundColor: 'primary.main', color: 'white' }}
                >
                  Add Files
                  <img src={plus} alt="plus" style={{ width: '20px', height: '20px', marginLeft: '10px' }} />
                </Button>
              </IconButton>
            </Tooltip>
          </Box>
        </Box>

        {/* Folder Grid/List as folder.subfolders.slice(0, visibleCount).map((subfolder, index) => ( */}
        <Grid container spacing={3} sx={{mb: 4}}>
                {folder.subfolders.map((folder) => (
                  <Grid item xs={12} sm={6} md={3} key={folder.id}>
                    <Box
                      sx={{
                        position: 'relative',
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        p: 3,
                        border: `2px solid ${theme.palette.divider}`,
                        borderRadius: 4,
                        boxShadow: theme.palette.mode === 'dark' ? 4 : 2,
                        backgroundColor: theme.palette.background.paper,
                        width: '100%',
                        height: 200,
                        ':hover': {
                          boxShadow: 6,
                          backgroundColor: theme.palette.action.hover,
                        },
                        overflow: 'hidden',
                        '&:hover .hover-icons': {
                          opacity: 1,
                        },
                      }}
        
                      // on double click then navigate to the folder/:id page
                      onDoubleClick={() => { navigate(`/folder/${folder.id}`) }}
                    >
                      {/* Hover Icons */}
                      <Box
                        className="hover-icons"
                        sx={{
                          position: 'absolute',
                          top: 10,
                          right: 10,
                          display: 'flex',
                          flexDirection: 'row',
                          gap: 1,
                          opacity: 0,
                          transition: 'opacity 0.3s',
                        }}
                      >
                        <IconButton aria-label="Share" size="small">
                          <ShareIcon fontSize="small" />
                        </IconButton>
                        <IconButton aria-label="Copy Link" size="small">
                          <LinkIcon fontSize="small" />
                        </IconButton>
                        {/* <IconButton aria-label="Delete" size="small" sx={{ color: 'error.main' }} onClick={() => { setModalOpen(true); setFolderName(folder.name); setFolderId(folder.id); } }>
                          <FontAwesomeIcon icon={faTrash} />
                        </IconButton> */}
                      </Box>
                      <FolderIcon
                        sx={{ fontSize: 80, color: theme.palette.grey[600], mb: 2 }}
                      />
                    </Box>
        
                    {/* Folder Name and Count */}
                    <Box
                      sx={{
                        m: 1,
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'flex-start',
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <FolderIcon fontSize="large" />
                      </Box>
                      <Box sx={{ ml: 1, textAlign: 'flex-start' }}>
                        <Typography variant="body1" noWrap sx={{ fontWeight: '600' }}>
                          {folder.name}
                        </Typography>
                        <Typography
                          variant="body2"
                          color="textSecondary"
                          noWrap
                          sx={{ fontWeight: '400', opacity: 0.7 }}
                        >
                          Total Items: {folder.count}
                        </Typography>
                      </Box>
                    </Box>
                  </Grid>
                ))}
              </Grid>
          

          <Typography variant="subtitle1" color="text.secondary" sx={{ fontWeight: 450, mb: 3 }}>
              Folders ({folder.subfolders.length}) 
          </Typography>

        {/* File Grid/List */}
        <Grid container spacing={2}>
        {folder.filesdata.slice(0, visibleCount).map((file, index) => (
            <Grid
              item
              xs={12}
              sm={isGridView ? 6 : 12}
              md={isGridView ? 4 : 12}
              lg={isGridView ? 3 : 12}
              key={file._id}
            >
              <motion.div whileHover={{ scale: 1.03 }} whileTap={{ scale: 0.98 }}>
                <Card
                  sx={{
                    boxShadow: '0px 4px 20px rgba(0,0,0,0.1)',
                    cursor: 'pointer',
                    borderRadius: 2,
                    overflow: 'hidden',
                    transition: 'transform 0.3s',
                    padding: '30px',
                    position: 'relative',
                    backgroundColor: 'background.paper',
                    '&:hover': {
                      transform: 'scale(1.05)',
                    },
                    border: selectedFileIndex === index ? '2px solid #fc0000' : 'none',
                  }}
                >
                  {
                    file.fileType === 'image' && (
                      <CardMedia
                        component={file.fileType === 'image' ? 'img' : 'video'}
                        image={file.fileType === 'image' ? `https://dprstorage.b-cdn.net${file.url}` : undefined}
                        // src={file.fileType === 'video' ? file.url : undefined}
                        controls={file.fileType === 'video'}
                        disablePictureInPicture={true}
                        alt={file.name}
                        sx={{
                          height: 150,
                          objectFit: 'contain',
                          pointerEvents: 'none',
                        }}
                        onClick={() => handleSelectFile(index)}
                      />
                    )
                  }

                  {
                    file.fileType === 'video' && (
                      <ReactPlayer
                        url={`https://dprstorage.b-cdn.net${file.url}`}
                        playing={false} // Autoplay the video
                        loop={false} // Loop the video
                        muted={true} // Mute the video by default
                        controls={false} // Disable all controls (no play, pause, volume, etc.)
                        width="100%"
                        height="100%"
                        style={{
                          objectFit: 'contain', // Ensures the video fits perfectly in the container
                        }}
                        config={{
                          file: {
                            attributes: {
                              controlsList: 'nodownload', // Prevents downloading the video
                              disablePictureInPicture: true, // Prevent picture-in-picture mode
                            },
                          },
                        }}
                        onClick={() => handleSelectFile(index)} // Optional, you can handle a click event here
                      />

                    )
                  }

                  {
                    file.fileType === 'document' && (
                      <iframe
                        src={`https://dprstorage.b-cdn.net${file.url}`}
                        style={{
                          width: '100%',
                          height: '150px',
                          objectFit: 'contain',
                          borderRadius: '0px',
                        }}
                        onClick={() => handleSelectFile(index)}
                      />
                    )
                  }

                  <Box sx={{ padding: 1 }}>
                    <Typography variant="subtitle1" noWrap sx={{ color: 'text.primary' }}>
                      {file.name}
                    </Typography>
                    <Typography variant="caption" color="text.secondary">
                      {
                        // if the file size is greater than 1MB, show the size in MB if not show in KB
                        file.size > 1024 * 1024 ? (
                          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                            {(file.size / (1024 * 1024)).toFixed(2)} MB
                          </Typography>
                        ) : (
                          <Typography variant="caption" sx={{ color: 'text.secondary' }}>
                            {(file.size / 1024).toFixed(2)} KB
                          </Typography>
                        )
                      }
                  </Typography>
                    <FontAwesomeIcon
                      icon={file.fileType === 'image' ? farImage : fasVideo}
                      style={{ marginLeft: 8, color: 'gray' }}
                    />
                  </Box>
                  <IconButton
                    sx={{
                      position: 'absolute',
                      top: 6,
                      right: 8,
                    }}
                    onClick={(e) => {
                      e.stopPropagation();
                      handleEditFile(file);
                    }}
                  >
                    <Edit />
                  </IconButton>

                  <Tooltip title="Delete File">
                    <IconButton
                      sx={{
                        position: 'absolute',
                        top: 6,
                        right: 40,
                        color: 'red',
                      }}
                      onClick={(e) => {
                        e.stopPropagation();
                        setModalOpen(true);
                        setFilename(file.name);
                        setFileId(file._id);
                        const filePath = file.url;
                        setFilepathName(filePath);
                      }}
                    >
                      <Delete />
                    </IconButton>
                  </Tooltip>
                  
                </Card>
              </motion.div>
            </Grid>
          ))}
        </Grid>

        {visibleCount < folder.files.length && (
          <Box sx={{ textAlign: 'center', mt: 3 }}>
            <Button variant="contained" onClick={handleShowMore}>
              Show More
            </Button>
          </Box>
        )}

        {isPreviewOpen && selectedFileIndex !== null && (
          <RightPreview file={folder.files[selectedFileIndex]} onClose={handleClosePreview} />
        )}

        <AddFileDrawer open={isDrawerOpen} onClose={handleDrawerClose} editingFile={editingFile} folderId={id}/>

        <MultiFileUploadDrawer open={isDrawerOpen1} onClose={handleDrawerClose1} folderId={id} key={id} />

        <CreateFolderDrawer open={drawerOpen} onClose={() => setDrawerOpen(false)} folderId={id} parent={id} />

        <Modal
      open={modalOpen}
      onClose={handleCloseModal}
      closeAfterTransition
      BackdropComponent={Backdrop}
      BackdropProps={{
        timeout: 500,
        sx: { bgcolor: 'rgba(0, 0, 0, 0.6)' }, // Semi-transparent backdrop for a modern feel
      }}
    >
      <Fade in={modalOpen}>
        <Box
          sx={{
            position: 'absolute',
            top: '50%',
            left: '50%',
            transform: 'translate(-50%, -50%)',
            width: { xs: '90%', sm: '400px' },
            bgcolor: 'background.paper',
            boxShadow: 24,
            borderRadius: 2,
            p: 4,
            textAlign: 'center',
          }}
        >
          <Typography variant="subtitle1" sx={{ fontWeight: '500', marginBottom: 2 }}>
            Are you sure you want to delete this : <b>{filename}</b> 
          </Typography>
          <Typography variant="body2" sx={{ color: 'text.secondary', marginBottom: 3 }}>
            This action cannot be undone. Make sure you really want to delete this folder.
          </Typography>
          <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2 }}>
            <Button
              variant="outlined"
              color="error"
              sx={{
                textTransform: 'none',
                fontWeight: 'bold',
                borderRadius: 2,
                paddingX: 3,
              }}
              onClick={handleCloseModal}
            >
              Cancel
            </Button>
            <Button
              variant="contained"
              color="primary"
              sx={{
                textTransform: 'none',
                fontWeight: 'bold',
                borderRadius: 2,
                paddingX: 3,
              }}
              onClick={() => {
                handleDeleteFile(fileId);
                handleCloseModal();
              }}
              >
              Confirm
            </Button>
          </Box>
        </Box>
      </Fade>
    </Modal>
        
      </Box>
    </>
  );
};

export default FolderDetails;